import { Component, OnInit, Inject, Input, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, throwMatDialogContentAlreadyAttachedError } from '@angular/material/dialog';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { CondPgP } from 'app/shared/interfaces/cong-pg-p';
import { Condpg } from 'app/shared/interfaces/condpg';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { Portador } from 'app/shared/interfaces/portador';
import { PortadorService } from 'app/shared/services/portador.service';
import { PageResult } from 'app/shared/interfaces/page-result';
import { TipoCobranca } from 'app/shared/interfaces/tipo-cobranca';
import { TipoCobrancaService } from 'app/shared/services/tipo-cobranca.service';
import { ClassificacaoGerencial } from 'app/shared/interfaces/classificacao-gerencial';
import { ClassificacaoGerencialService } from 'app/shared/services/classificacao-gerencial.service';
import { CondpgService } from 'app/shared/services/condpg.service';
import { ILayoutConf, LayoutService } from 'app/shared/services/layout.service';

@Component({
  selector: 'app-condpg-popup',
  templateUrl: 'condpg-popup.component.html',
  styleUrls: ['condpg-popup.component.scss']
})
export class CondpgPopupComponent implements OnInit {

  public itemForm: FormGroup;
  _parcelaForm: FormGroup;


  private isLoadingPortador = false;
  private isLoadingTipoCobranca = false;
  private isLoadingClassificacaoG = false;
  parcelaList$: BehaviorSubject<CondPgP[]> = new BehaviorSubject<CondPgP[]>(null);
  condPgPs: CondPgP[];
  condPgP: CondPgP;
  portadores: Portador[];
  portadores$ = new BehaviorSubject<Portador[]>([]);
  portador: Portador;
  tipoCobrancas: TipoCobranca[];
  tipoCobrancas$ = new BehaviorSubject<TipoCobranca[]>([]);
  tipoCobranca: TipoCobranca;
  classificacaoGs: ClassificacaoGerencial[];
  classificacaoG: ClassificacaoGerencial;
  cep: any;
  isLoading = false;
  isLoadingGrupo = false;
  errorMsg: string;

  desativado: any;
  alterar: any;

  public searchInput = '';

  maskFone = {
    mask: '(00) {*}0000-0000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCep = {
    mask: '00000-000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCpf = {
    mask: '000.000.000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCnpj = {
    mask: '00.000.000/0000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };
  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };
  maskLower = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toLowerCase()
  };

  maskEmail = {
    mask: /^\S*@?\S*$/,
    prepare: (email: any) => email.toLowerCase()
  };



  rows = [];
  isEditable = {};
  labels = [];
  layoutConf: ILayoutConf;
  searching: boolean;
  saving: boolean;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CondpgPopupComponent>,
    private confirmService: AppConfirmService,
    private condPgService: CondpgService,
    private portadorService: PortadorService,
    private tipoCobrancaService: TipoCobrancaService,
    private classificacaoGerencialService: ClassificacaoGerencialService,
    private fb: FormBuilder,
    private _parcelaFb: FormBuilder,
    public layout: LayoutService
  ) { }


  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
    this.buildItemForm(this.data.payload);
    this.portadorService.getPortadorPage(1, 100).subscribe(val => this.portadores$.next(val.content));
    this.tipoCobrancaService.getTipoCobrancaPage(1, 100).subscribe(val => this.tipoCobrancas$.next(val.content));
    this.portadores$.subscribe(ps => this.portadores = ps);
    this.tipoCobrancas$.subscribe(tc => this.tipoCobrancas = tc);
  }

  buildItemForm(item: Condpg) {
    this.parcelaList$.next(item?.parcelaList?.sort((a, b) => a.parcela - b.parcela));
    this.itemForm = this.fb.group({
      id: [item?.id],
      uuid: [item?.uuid],
      codigo: [item?.codigo, [Validators.required]],
      parcelas: [item?.parcelas, [Validators.required]],
      desativado: [item?.desativado],
      descricao: [item?.descricao, [Validators.required]],
      prazoParcelas: [item?.prazoParcelas, [Validators.required]],
      vctoAPartir: [item?.vctoAPartir, [Validators.required]],
      parcelaList: [item?.parcelaList],
      alteraParcela: [item?.alteraParcela],
      percDescontoMin: [item?.percDescontoMin],
      percDescontoMax: [item?.percDescontoMax],
      percDescontoPadrao: [item?.percDescontoPadrao],
    });



  }

  buildParcelaForm(item: CondPgP) {
    this.condPgP = item;
    this._parcelaForm = this._parcelaFb.group({
      id: [item.id],
      uuid: [item.uuid],
      parcela: [item.parcela],
      diasEmissao: [item.diasEmissao],
      percentual: [item.percentual],
      financPortador: [item.financPortador],
      searchPortador: [''],
      financTipoCobranca: [item.financTipoCobranca],
      searchTipoCobranca: [''],
      financClassificacaoG: [item.financClassificacaoG],
      searchClassificacaoG: [],
    });

    this._parcelaForm.get('searchClassificacaoG').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.searching = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.classificacaoGerencialService.getClassificacaoGPageSearch(1, 10, value) :
            this.classificacaoGerencialService.getClassificacaoGPage(1, 10)) : new Observable<PageResult<ClassificacaoGerencial>>())
          .pipe(
            finalize(() => this.searching = false),
          )
        )
      )
      .subscribe(classificacoes => {
        this.classificacaoGs = classificacoes.content;

        if (this.condPgP.financClassificacaoG !== undefined && this.condPgP.financClassificacaoG !== null) {
          if (this.classificacaoGs.map(n => n.id).includes(this.condPgP.financClassificacaoG.id)) {
            const financClassificacaoG = this.classificacaoGs.find(n => n.id === this.condPgP.financClassificacaoG.id) ?? this.condPgP.financClassificacaoG;
            if (financClassificacaoG !== null && financClassificacaoG !== undefined) {
              this.itemForm.controls['financClassificacaoG'].setValue(financClassificacaoG);
            }
          } else {
            this.classificacaoGs.push(this.condPgP.financClassificacaoG);
          }
        }

      });

    this._parcelaForm.get('searchPortador').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.searching = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.portadorService.getPortadorPageSearch(1, 10, value) :
            this.portadorService.getPortadorPage(1, 10)) : new Observable<PageResult<Portador>>())
          .pipe(
            finalize(() => this.searching = false),
          )
        )
      )
      .subscribe(portadores => {
        this.portadores = portadores.content;
        if (this.condPgP.financPortador !== undefined && this.condPgP.financPortador !== null) {
          if (this.portadores.map(n => n.id).includes(this.condPgP.financPortador.id)) {
            const financPortador = this.portadores.find(n => n.id === this.condPgP.financPortador.id) ?? this.condPgP.financPortador;
            if (financPortador !== null && financPortador !== undefined) {
              this.itemForm.controls['financPortador'].setValue(financPortador);
            }
          } else {
            this.portadores.push(this.condPgP.financPortador);
          }
        }

      }
      );

    this._parcelaForm.get('searchTipoCobranca').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.searching = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.tipoCobrancaService.getTipoCobrancaPageSearch(1, 10, value) :
            this.tipoCobrancaService.getTipoCobrancaPage(1, 10)) : new Observable<PageResult<TipoCobranca>>())
          .pipe(
            finalize(() => this.searching = false),
          )
        )
      )
      .subscribe(tipos => {
        this.tipoCobrancas = tipos.content;
        if (this.condPgP.financTipoCobranca !== undefined && this.condPgP.financTipoCobranca !== null) {
          if (this.tipoCobrancas.map(n => n.id).includes(this.condPgP.financTipoCobranca.id)) {
            const financTipoCobranca = this.tipoCobrancas.find(n => n.id === this.condPgP.financTipoCobranca.id) ?? this.condPgP.financTipoCobranca;
            if (financTipoCobranca !== null && financTipoCobranca !== undefined) {
              this.itemForm.controls['financTipoCobranca'].setValue(financTipoCobranca);
            }
          } else {
            this.tipoCobrancas.push(this.condPgP.financTipoCobranca);
          }
        }
      }
      );
  }

  onFocusPortador(event: FocusEvent) {

  }

  onSelectionChangePortador(event: any): void {
    console.log(event);

    if (event.value !== undefined) {
      this.portador = event.value;
      this._parcelaForm.patchValue({ financPortador: this.portador })
    }
  }

  displayFnPortador(portador: Portador) {
    if (portador) {
      return `${portador.codigo.toString().padStart(3, '0')} - ${portador.descricao.trim()}`;
    }
  }

  onFocusTipoCobranca(event: FocusEvent) {

  }

  onSelectionChangeTipoCobranca(event: any): void {
    if (event.option.value !== undefined) {
      this.tipoCobranca = event.option.value;
      this._parcelaForm.patchValue({ financTipoCobranca: this.tipoCobranca })

    }
  }

  displayFnTipoCobranca(tipoCobranca: TipoCobranca) {
    if (tipoCobranca) {
      return `${tipoCobranca.codigo.toString().padStart(3, '0')} - ${tipoCobranca.descricao.trim()}`;
    }
  }

  onFocusClassificacaoG(event: FocusEvent) {

  }

  onSelectionChangeClassificacaoG(event: any): void {
    if (event.option.value !== undefined) {
      this.classificacaoG = event.option.value;
      this._parcelaForm.patchValue({ financClassificacaoG: this.classificacaoG })
    }
  }

  displayFnClassificacaoG(classificacacaoG: ClassificacaoGerencial) {
    if (classificacacaoG) {
      return `${classificacacaoG?.codigo.toString().padStart(3, '0')} - ${classificacacaoG?.descricao.trim()}`;
    }
  }


  // Save row
  saveRow(rowIndex: string) {
    this.isEditable[rowIndex] = !this.isEditable[rowIndex];
    this.condPgService.saveOrUpdateParcela(this._parcelaForm.value).subscribe(parcelas => this.parcelaList$.next(parcelas.sort((a, b) => a.parcela - b.parcela)));
  }

  // Delete row
  delete(row: any, rowIndex: string) {
    this.isEditable[rowIndex] = !this.isEditable[rowIndex]
    console.log('Row deleted: ' + rowIndex);
  }

  submit() {
    // console.log( this.itemForm.value.endereco);
    // this.itemForm.value.inscricaoFederal = this.itemForm.value.cpfCnpj;
    // this.itemForm.value.cpf = this.itemForm.value.cpfCnpj;
    // this.itemForm.value.rg = this.itemForm.value.rgInscricao;
    // this.itemForm.value.inscricaoEstadual = this.itemForm.value.rgInscricao;
    this.dialogRef.close(this.itemForm.value)
  }

  save() {
    this.saving = true;
    this.itemForm.value.parcelaList = null;
    this.condPgService.saveOrUpdate(this.itemForm.value).subscribe(
      val => {
        console.log(val);
        this.saving = false;
        this.confirmService.confirm({
          title: 'SALVAR',
          message: 'OK, Condição de Pgto Salvo com Sucesso!', error: false
        });
        this.buildItemForm(val);
      },
      err => {
        this.confirmService.confirm({
          title: 'ERRO AO SALVAR, VERIFIQUE',
          message: err.error.status, error: true
        })
      });
  }

  close() {
    this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close(false);
        }
      });
  }

}
